export default __webpack_public_path__ + "static/media/explore.8d539b91.svg";